<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight set">
        <!-- 账号设置 [[ -->
        <div class="account-settings">
            <div class="as-title">
                <h5 class="f-inlineblock-top as-title-con">应用申请</h5>
            </div>
            <div>
                <ul class="as-inf-fill-in">
                    <li class="as-fill-in-box as-personal-inf">
                        <h5 class="as-inf-tit">
                            <span class="ico ico-business-card f-inlineblock-middle"></span>
                            <p class="f-inlineblock-top as-inf-tit-text">应用申请</p>
                        </h5>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top">*应用名称</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray"
                                       type="text"
                                       autocomplete="off"
                                       placeholder="请填写应用名称(30个字以内)"
                                       v-model="appParams.appname"
                                >
                            </div>
                        </div>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top">*应用描述</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray"
                                       type="text"
                                       autocomplete="off"
                                       placeholder="请填写应用描述(10~150个字)"
                                       v-model="appParams.appdesc"
                                >
                            </div>
                        </div>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top">*应用官网</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray"
                                       type="text"
                                       autocomplete="off"
                                       placeholder="请填写官网链接(请以http://或https://开头)"
                                       v-model="appParams.home"
                                >
                            </div>
                        </div>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top">*授权回调链接</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray"
                                       type="text"
                                       autocomplete="off"
                                       placeholder="请填写授权回调链接(请以http://或https://开头)"
                                       v-model="appParams.redirectUrl"
                                >
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="bottom-btn">
                    <a class="auditing_btn g-btn" href="javascript:;" @click="submitForm()">提交审核</a>
                </div>
            </div>
        </div>
        <!-- 账号设置 ]] -->

        <!-- 账号设置-已通过 [[ -->

        <div class="account-settings-passed">
            <!-- <div class="account-settings-passed"> -->
            <div class="as-title f-clearfix">
                <h5 class="f-fl as-title-con">应用申请列表</h5>
            </div>
            <ul class="as-inf-fill-in">
                <li class="as-fill-in-box as-personal-inf">
                    <h5 class="as-inf-tit">
                        <span class="ico ico-business-card f-inlineblock-middle"></span>
                        <p class="f-inlineblock-top f-hide-col-1 as-inf-tit-text">应用信息</p>
                    </h5>
                </li>
            </ul>
            <div style="width: 860px;margin: 10px auto;">
                <table class="app-table">
                    <thead>
                        <th width="180" class="app-title">应用名称</th>
                        <th width="180" class="app-title">应用描述</th>
                        <th width="180" class="app-title">应用官网地址</th>
                        <th width="180" class="app-title">授权回调链接</th>
                        <th width="100" class="app-title">状态</th>
                        <th width="100" class="app-title">操作</th>
                    </thead>
                    <tbody>
                        <tr v-for="item of appList" :key="item.appkey">
                            <td>{{item.appname}}</td>
                            <td>{{item.appdesc}}</td>
                            <td style="word-break: break-all;">{{item.home}}</td>
                            <td style="word-break: break-all;">{{item.callbackurl || '-'}}</td>
                            <td>{{getStatus(item)}}<span style="padding: 0 3px;cursor: pointer;color: #FD7E28;" v-if="item.rejectmark" :title="item.rejectmark">？</span></td>
                            <td>
                                <div class="control-box">
                                    <el-button size="small" plain @click="getAppInfo(item.appkey)">查看详情</el-button>
                                </div>
                                <div class="control-box">
                                    <el-button size="small" plain @click="getApplicationUser(item.appkey)">查看用户</el-button>
                                </div>
                                <div class="control-box">
                                    <el-button size="small" plain @click="deleteApp(item.appkey)">删除应用</el-button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5" v-if="appList.length === 0" style="text-align: center;">暂无数据</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <el-dialog title="应用详情" :visible.sync="isShowDetail">
                <el-form ref="form" :model="appInfo" label-width="120px">
                    <el-form-item label="应用名称：">
                        {{appInfo.appname}}
                    </el-form-item>
                    <el-form-item label="应用描述：">
                        {{appInfo.appdesc}}
                    </el-form-item>
                    <el-form-item label="公司官网：">
                        {{appInfo.home}}
                    </el-form-item>
                    <el-form-item label="授权回调链接：">
                        {{appInfo.callbackurl}}
                    </el-form-item>
                    <el-form-item label="应用key：">
                        {{appInfo.appkey}}
                    </el-form-item>
                    <el-form-item label="应用secret：">
                        {{appInfo.appsecret}}
                    </el-form-item>
                </el-form>
            </el-dialog>
            <el-dialog title="授权用户列表" :visible.sync="isShowList">
                <el-table
                    :data="appUserList"
                    border
                    height="300"
                    style="width: 100%">
                    <el-table-column
                        prop="username"
                        label="用户名称">
                    </el-table-column>
                    <el-table-column
                        prop="openid"
                        label="用户openid">
                    </el-table-column>
                </el-table>
            </el-dialog>
        </div>
        <!-- 账号设置-已通过 ]] -->
    </div>
</template>

    <!-- 右边主体]] -->
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/set/set.scss';
    .app-table{
        width: 100%;
        text-align: left;
        color: #909399;    
        border-top: 1px solid #ebeef5;
        border-left: 1px solid #ebeef5;
        font-size: 14px;
        line-height: 26px;
        th,td{
            padding: 12px 10px;
            border-right: 1px solid #ebeef5;
            border-bottom: 1px solid #ebeef5;
        }
        td{
            color: #333;
        }
        .control-box{
            text-align: center;
            margin: 10px;
        }
    }
    .set .account-settings-passed .as-inf-fill-in{
        width: 686px;
    }
    .as-agreement-con{cursor: pointer}
    .set .account-settings .upload-photo {
        position: relative;
        margin-left: 22px;
    }
    .set .account-settings .up-already-upload {
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 14px;
        color: #FD7E28;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        line-height: 20px;
    }
    .reject-reason{
        font-size: 14px;
        padding-right: 10px;
        color: red;
    }
</style>

<script>
import {
    ApplicationApply, ApplicationInfo, ApplicationList, ApplicationDelete, ApplicationUser 
} from 'Services/getData.js';
export default {
    data() {
        return {
		    appParams: {
			    appname: "",
			    appdesc: '',
			    home: '',
                redirectUrl: ''
            },
            appInfo: {
                appname: "",
			    appdesc: '',
                home: '',
                appkey: '',
                appsecret: ''
            },
            appList: [],
            appUserList: [],
            isShowDetail: false,
            isShowList: false
        }
    },
    components: {},
    created(){
        this.getApplicationList();
    },
    mounted(){
    },
    methods: {
        reset(){
            this.appParams.appname = ''
            this.appParams.appdesc = ''
            this.appParams.home = ''
            this.appParams.redirectUrl = ''
        },
        getStatus(item){
            switch(item.status){
            case 0:
                return '初始待审核';
            case 1:
                return '审核通过';
            case 2:
                return '审核驳回';
            }
        },
        async getApplicationUser(appkey){
            this.appUserList = [];
            this.isShowList = true;
            let res = await ApplicationUser({
                appkey: appkey
            });
            if(res.status === 200 && res.data.code === 0){
                this.appUserList = res.data.data;
            }
        },
        deleteApp(appkey){
            this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await ApplicationDelete({
                    appkey: appkey
                });
                if(res.status === 200 && res.data.code === 0){
                    this.$alert('删除成功');
                    this.getApplicationList();
                }
            }).catch(() => {});
        },
        async getApplicationList(){
            let res = await ApplicationList();
            if(res.status === 200 && res.data.code === 0){
                this.appList = res.data.data;
            }
        },
        async getAppInfo(appkey){
            this.appInfo = {
                appname: "",
			    appdesc: '',
                home: '',
                appkey: '',
                appsecret: ''
            };
            this.isShowDetail = true;
            let res = await ApplicationInfo({
                appkey: appkey
            });
            if(res.status === 200 && res.data.code === 0){
                this.appInfo = res.data.data;
            }
        },
	    async submitForm (){
		    if(!this.validateForm()){
			    return false;
            }
            let res = await ApplicationApply(this.appParams);
            if(res.data.code === 0){
                this.$alert('申请成功');
                this.reset();
                this.getApplicationList();
            }
        },
        validateForm () {
            if(!this.appParams.appname){
                this.$alert('应用名称不能为空');
                return false;
            }
            if(this.appParams.appname.length>30){
                this.$alert('应用名称长度30个字符以内');
            }
            if(!this.appParams.appdesc){
                this.$alert('应用描述不能为空');
                return false;
            }else{
                if(this.appParams.appdesc.length<10 || this.appParams.appdesc.length>150){
                    this.$alert('应用描述长度介于10-150个字符之间');
                    return false;
                }
            }
            if(!this.appParams.home){
                this.$alert('应用官网不能为空');
                return false;
            }else{
                // 链接校验
                let regLink = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
                if(!regLink.test(this.appParams.home)){
                    this.$alert('请输入正确的官网链接')
                    return false;
                }
            }
            if(!this.appParams.redirectUrl){
                this.$alert('授权回调链接不能为空');
                return false;
            }else{
                // 链接校验
                let regLink = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
                if(!regLink.test(this.appParams.redirectUrl)){
                    this.$alert('请输入正确的回调链接')
                    return false;
                }
            }
	        return true;
        }
    }
}
</script>
